import { BrowserCacheLocation, LogLevel } from "@azure/msal-browser";

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

const keycloakConfig = {
  config: {
    realm: 'marketplace-seller',
    url: 'https://sso-marketplace-rec1.fd-recette.net/',
    clientId: 'front-sellers',
  },
  initOptions: {
    onLoad: 'check-sso',
  }
}


const ssoConfig = {
  auth: {
    clientId: 'a0a8ca96-9460-4613-8454-f65ebeda6cbb',
    authority: 'https://login.microsoftonline.com/ee736e01-987f-46aa-a144-79812f19df56',
    redirectUri: 'https://catalog-mp-rec1-fd.fd-recette.net/'
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
    storeAuthStateInCookie: isIE,
  },
  system: {
    loggerOptions: {
      loggerCallback(logLevel: LogLevel, message: string) {
        // console.log(message);
      },
      logLevel: LogLevel.Verbose,
      piiLoggingEnabled: false
    }
  }

}

export const environment = {
  api_url: 'https://catalog-mp-rec1-fd.fd-recette.net/api/',
  environment: 'rec1',
  datadog_env: 'rec1',
  keycloakConfig: keycloakConfig,
  msalConfig: ssoConfig,
  docsBucketUrl:'https://catalog-mp-rec1-fd.fd-recette.net/medias/doc/',
  docApiServerUrl: 'https://catalog-mp-rec1-fd.fd-recette.net/'
};

